import { loadStripe } from "@stripe/stripe-js"

export const STRIPE_PROMISE = loadStripe(import.meta.env.VITE_STRIPE_KEY)
export const RATES_HREF = "https://www.mcallenairport.com/parking.html"
export const DEFAULT_HELP_EMAIL = "parkmfe@interstateparking.com"
export const DEFAULT_HELP_PHONE = "9562138561"
export const DEFAULT_TIME_ZONE = "America/Chicago"
